import { API_BASE_URL, API_TOKEN } from './config';

export const fetchConversations = async () => {
    const fd = new FormData();
    fd.append('action', "fetchConversations");
    fd.append('API_TOKEN', API_TOKEN);
  
    try {
      const response = await fetch(API_BASE_URL, {
        method: 'POST',
        credentials: "include",
        //headers: { "Content-Type": "application/json" },
        body: fd,
      });
      const data = await response.json();
      //alert(data.message);
      //console.log(data);
      return data;
    } catch (error) {
      console.error('Error creating team:', error);
      throw error;
    }
};

export const fetchMessages = async (username) => {
    const fd = new FormData();
    fd.append('action', "fetchMessages");
    fd.append('API_TOKEN', API_TOKEN);
  //alert(username);
    fd.append('username', username);
    try {
      const response = await fetch(API_BASE_URL, {
        method: 'POST',
        credentials: "include",
        //headers: { "Content-Type": "application/json" },
        body: fd,
      });
      const data = await response.json();
      //alert(data.message);
      //console.log(data);
      return data;
    } catch (error) {
      console.error('Error creating team:', error);
      throw error;
    }
};

export const accept_or_reject_new_team_member = async (identifier, verdict) => {
    const fd = new FormData();
    fd.append('action', "acceptOrRejectNewTeamMember");
    fd.append('API_TOKEN', API_TOKEN);

    fd.append('identifier', identifier);  
    fd.append('verdict', verdict); 
    try {
        const response = await fetch(API_BASE_URL, {
        method: 'POST',
        credentials: "include",
        //headers: { "Content-Type": "application/json" },
        body: fd,
        });
        const data = await response.json();
        alert(data.message);
        //console.log(data);
        return data;
    } catch (error) {
        console.error('Error creating team:', error);
        throw error;
    }
}

export const clear_message = async (identifier) => {
    const fd = new FormData();
    fd.append('action', "clearMessage");
    fd.append('API_TOKEN', API_TOKEN);

    fd.append('identifier', identifier);  
    try {
        const response = await fetch(API_BASE_URL, {
        method: 'POST',
        credentials: "include",
        //headers: { "Content-Type": "application/json" },
        body: fd,
        });
        const data = await response.json();
        //alert(data.message);
        //console.log(data);
        return data;
    } catch (error) {
        console.error('Error creating team:', error);
        throw error;
    }
}

export const accept_or_reject_coach_invite = async (identifier, verdict) => {
    const fd = new FormData();
    fd.append('action', "acceptOrRejectCoachInvite");
    fd.append('API_TOKEN', API_TOKEN);

    fd.append('identifier', identifier);  
    fd.append('verdict', verdict); 
    try {
        const response = await fetch(API_BASE_URL, {
        method: 'POST',
        credentials: "include",
        //headers: { "Content-Type": "application/json" },
        body: fd,
        });
        const data = await response.json();
        alert(data.message);
        //console.log(data);
        return data;
    } catch (error) {
        console.error('Error creating team:', error);
        throw error;
    }
}

//Dummy data template still in use
export const fetchOlderMessages = async () => {
    // Predefined JSON for older messages
    const olderMessages = [
        {
            sender: "Chat Master",
            username: "chatmaster",
            content: "Yesterday's discussion really helped shape the project. Let's keep the momentum going! <button onclick='alert(1)'>Yes</button>",
            timestamp: "2023-10-02T14:00:00Z",
            status: "old"
        }
    ];

    // Simulate an API request with a delay
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({ data: olderMessages });
        }, 0);
    });
};

// Dummy data functions no longer in use
export const fetchConversations1 = async () => {
    // Predefined JSON for messages
    const messages = [
        {
            sender: "Chat Master",
            username: "chatmaster",
            status: "new"
        },
        {
            sender: "You",
            username: "you",
            status: "new"
        },
        {
            sender: "Chat Master",
            username: "chatmaster",
            status: "new"
        },
        {
            sender: "You",
            username: "you",
            status: "old"
        },
        {
            sender: "Chat Master",
            username: "chatmaster",
            status: "new"
        },
        {
            sender: "You",
            username: "you",
            status: "old"
        },
        {
            sender: "Chat Master",
            username: "chatmaster",
            status: "new"
        },
        {
            sender: "You",
            username: "you",
            status: "new"
        }
    ];

    // Simulate an API request with a delay
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({ data: messages });
        }, 0);
    });
};
export const fetchMessages1 = async () => {
    // Predefined JSON for messages
    const messages = [
        {
            sender: "Chat Master",
            username: "chatmaster",
            content: "Good morning! Ready to make today a success? I sent you the initial draft last night.",
            timestamp: "2023-10-03T08:00:00Z",
            status: "new"
        }
        /*{
            sender: "You",
            username: "you",
            content: "Morning, James! I reviewed the draft and have a few creative ideas. Let's discuss what works best.",
            timestamp: "2023-10-03T08:05:00Z",
            status: "new"
        },
        {
            sender: "Chat Master",
            username: "chatmaster",
            content: "Fantastic! How about we start with the project scope and address any concerns upfront?",
            timestamp: "2023-10-03T08:10:00Z",
            status: "new"
        },
        {
            sender: "You",
            username: "you",
            content: "That sounds perfect. We can refine the details and align our strategies as we progress.",
            timestamp: "2023-10-03T08:15:00Z",
            status: "old"
        },
        {
            sender: "Chat Master",
            username: "chatmaster",
            content: "Don't forget to consider the latest market trends; they might offer extra insights for our pitch.",
            timestamp: "2023-10-03T08:20:00Z",
            status: "new"
        },
        {
            sender: "You",
            username: "you",
            content: "I've gathered recent market analytics, which should add a robust edge to our presentation.",
            timestamp: "2023-10-03T08:25:00Z",
            status: "old"
        },
        {
            sender: "Chat Master",
            username: "chatmaster",
            content: "Excellent update! After our meeting, let's compile a detailed report that ties all these ideas together.",
            timestamp: "2023-10-03T08:30:00Z",
            status: "new"
        },
        {
            sender: "You",
            username: "you",
            content: "Agreed. I’m excited about our collaboration and the clear, dynamic direction we're headed. See you soon!",
            timestamp: "2023-10-03T08:35:00Z",
            status: "new"
        }*/
    ];

    // Simulate an API request with a delay
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({ data: messages });
        }, 0);
    });
};


/*
const fd = new FormData();fd.append('action', 'fetchUsers');fd.append('API_TOKEN', 'whenweallfallasleepwheredowego');try {const response = await fetch(API_BASE_URL, {method: 'POST', body: fd,});const data = await response.json();console.log(data);return data;} catch (error) {console.error('Error fetching user profiles:', error);throw error;}
*/